import { useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { cards, hardcards, color } from "../Data/cards";
import styles from "./game.module.css";
import Card from "./card";
import SkeletonCard from "./skeletonCard";
import { MyContext } from "../utils/utils";
import { db } from "../utils/firebase";
import { ref, onValue, set, update } from "firebase/database";
import { Button, message, notification } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  eckCircleFilled,
  DownCircleTwoTone,
  ExclamationCircleTwoTone,
  PlayCircleFilled,
  RedoOutlined,
  RightCircleTwoTone,
  SmileOutlined,
  UndoOutlined,
} from "@ant-design/icons";
const AllCard = ({ state }) => {
  const { key } = useParams();

  const { currentUser } = useContext(MyContext);
  const [currentJoiner, setCurrentJoiner] = useState(null);
  const [currentCard, setCurrentCard] = useState(null);
  const [previousCard, setPreviousCard] = useState(null);
  const [joiners, setJoiners] = useState(null);
  const [joinerNum, setJoinerNum] = useState(0);
  const [userIdx, setUserIdx] = useState(0);
  const [direction, setDirection] = useState(null);

  const [mode, setMode] = useState(null);
  const [cardSelected, setCardSelected] = useState(false);
  const [nextJoiner, setNextJoiner] = useState(false);

  const [allCards, setAllCards] = useState(cards);

  const directionStyle = { color: "#bae7ff", fontSize: `350px` };
  var tempCard = null;
  var tempJoiner = null;

  useEffect(() => {
    const gameRef = ref(db, "rooms/" + key + "/joiner");
    if (currentUser == null) return;
    onValue(gameRef, (snapshot) => {
      const val = snapshot.val();
      if (val) {
        setUserIdx(Object.keys(val).indexOf(currentUser.uid));
        setJoiners(val);
        if (val.length != joinerNum) {
          setJoinerNum(val.length);
        }
      }
    });

    const joinerRef = ref(db, "rooms/" + key + "/currentJoiner");

    onValue(joinerRef, (snapshot) => {
      const val = snapshot.val();
      if (val) {
        setCurrentJoiner(val);
        setNextJoiner(false);
        tempJoiner = val;
      }
    });

    const currentCardref = ref(db, "rooms/" + key + "/currentCard");
    onValue(currentCardref, (snapshot) => {
      const val = snapshot.val();
      if (val) {
        setPreviousCard(tempCard);
        setCurrentCard(val);
        tempCard = val;
        var target = document.getElementById("currentCard");
        const ratio = getAngleCurrentJoiner(tempJoiner);
        const angle = (ratio * 2 + 1 / 2) * Math.PI;
        var left = -170 * Math.cos(angle);
        var top = 190 * Math.sin(angle);
        if (target) {
          var player = target.animate(
            [
              {
                transform: `translate(${left}px, ${top}px) scale(0.3)`,
                opacity: 0,
              },
              { transform: "translate(0, 0)", opacity: 1 },
            ],
            1000
          );
          player.addEventListener("finish", function () {
            target.style.transform = "translate(0px, 0px)";
          });
        }
      }
    });

    onValue(ref(db, "rooms/" + key + "/selecting"), (snapshot) => {
      const val = snapshot.val();
      setCardSelected(val);
    });

    onValue(ref(db, "rooms/" + key + "/direction"), (snapshot) => {
      const val = snapshot.val();
      setDirection(val);
    });

    onValue(ref(db, "rooms/" + key + "/mode"), (snapshot) => {
      const val = snapshot.val();
      setMode(val);
      if (val.hard) {
        setAllCards(cards.concat(hardcards));
      }
    });
  }, [
    db,
    currentUser,
    document.getElementById("currentCard"),
    document.getElementById("direction"),
  ]);

  const [arrowAngle, setArrowAngle] = useState(null);
  useEffect(() => {
    const ratio = getAngleCurrentJoiner(currentJoiner);
    var angle = Math.round((1 - ratio) * 360);
    if (direction == "CW") angle -= 8;
    else if (direction == "CCW") angle += 8;
    rotateArrow(arrowAngle, angle);
    setArrowAngle(angle);
  }, [currentJoiner, joinerNum]);

  const rotateArrow = (prev, cur) => {
    if (cur == null || isNaN(cur)) return;
    if (prev == null || isNaN(prev)) prev = cur;
    var target = document.getElementById("direction");
    if (target) {
      var distance = 1;

      if (direction == "CW" && prev > cur) {
        cur += 360;
      } else if (direction == "CCW" && prev < cur) {
        cur -= 360;
      }
      if (direction != null) {
        distance = Math.round(Math.abs(prev - cur) / 120);
        console.log(prev, cur);
      }
      console.log(target, distance);
      var player = target.animate(
        [
          {
            transform: `rotate(${prev}deg)`,
          },
          {
            transform: `rotate(${cur}deg)`,
          },
        ],
        1000 * distance
      );
      player.addEventListener("finish", function () {
        target.style.transform = `rotate(${cur}deg)`;
      });
    }
  };

  const getAngleCurrentJoiner = (tempJoiner) => {
    if (tempJoiner == null) return;
    if (joiners == null) return;
    const index = Object.keys(joiners).indexOf(tempJoiner);
    const length = Object.keys(joiners).length;
    var ratio;
    var idx = index - userIdx;
    if (idx < 0) idx += length;
    ratio = idx / length;
    return ratio;
  };

  const getRandom = (min, max, num) => {
    var arr = [];
    while (arr.length < num) {
      var r = parseInt(Math.random() * (max - min) + min);
      if (arr.indexOf(r) === -1) arr.push(r);
    }
    return arr;
  };

  const startPlay = () => {
    onValue(
      ref(db, "rooms/" + key + "/joiner"),
      (snapshot) => {
        const val = snapshot.val();
        const number = Object.keys(val).length;
        if (number == 1) {
          message.error("참가자가 2명 이상이어야 합니다");
          return;
        }
        var cardNum = 3;
        if (number == 2) {
          cardNum = 7;
        } else if (number == 3) {
          cardNum = 6;
        } else if (number == 4) {
          cardNum = 5;
        } else if (number == 5 || number == 6) {
          cardNum = 4;
        }
        const randomArr = getRandom(0, allCards.length, number * cardNum);
        var start = 0;
        for (var uid in val) {
          var joinerCards = [];
          for (var i = start; i < start + cardNum; i++) {
            joinerCards.push(allCards[randomArr[i]]);
          }
          update(ref(db, "rooms/" + key + "/joiner/" + uid), {
            cards: joinerCards,
            middleJoin: null,
          });
          start += cardNum;
        }

        var leftCards = allCards.filter((x, idx, _) => {
          return !randomArr.includes(idx);
        });

        var currentCard;
        do {
          const arr = getRandom(0, leftCards.length, 1);
          currentCard = leftCards[arr[0]];
        } while (
          currentCard.color == color.black ||
          currentCard.color == color.white
        );
        update(ref(db, "rooms/" + key), {
          currentJoiner: Object.keys(val)[0],
          currentCard: currentCard,
          leftCards: leftCards,
          state: "PLAY",
          direction: "CW",
        });
      },
      {
        onlyOnce: true,
      }
    );
  };

  const checkDistance = (index) => {
    if (!mode.distance) return true;
    var distance = Math.abs(index - userIdx);
    var len = Object.keys(joiners).length;
    if (distance > len / 2) {
      distance = len - distance;
    }
    if (currentCard.distance == null || distance <= currentCard.distance) {
      return true;
    }
    notification.open({
      message: "현재 카드 거리 이내의 사람을 선택하세요",
      icon: <ExclamationCircleTwoTone />,
    });
    return false;
  };

  const [iconColor, setIconColor] = useState("#bae7ff");
  const selectJoiner = (userKey, index) => {
    if (
      cardSelected &&
      currentJoiner == currentUser.uid &&
      userKey != currentUser.uid
    ) {
      if (checkDistance(index)) {
        setNextJoiner(userKey);
      } else {
      }
    }
  };

  return (
    <div className={state == "PLAY" ? styles.allCard : styles.allCardFull}>
      {joiners &&
        Object.keys(joiners).map((key, index) => {
          const value = joiners[key];
          const length = Object.keys(joiners).length;
          var angle;
          var idx = index - userIdx;
          if (idx < 0) idx += length;
          angle = (idx / length) * 2 * Math.PI + Math.PI / 2;
          var left = `calc(50% - ${45 * Math.cos(angle)}% - 40px)`;
          var top = `calc(50% + ${180 * Math.sin(angle)}px - 30px)`;

          if (value.cards != null && idx != 0) {
            if (idx > length / 2) {
              left = `calc(50% - ${50 * Math.cos(angle)}% - 40px)`;
            } else {
              left = `calc(50% - ${50 * Math.cos(angle)}% - 40px)`;
            }
            top = `calc(50% + ${190 * Math.sin(angle)}px - 40px)`;
          } else if (idx == 0) {
            left = `calc(50% - ${180 * Math.cos(angle)}px - 30px)`;
            top = `calc(50% + ${190 * Math.sin(angle)}px - 30px)`;
          }

          return (
            <div
              style={{
                position: "absolute",
                left: left,
                top: top,
                zIndex: "1",
              }}
              onClick={() => selectJoiner(key, index)}
            >
              {idx != 0 ? (
                <SkeletonCard
                  number={value.cards ? value.cards.length : 0}
                  userKey={
                    currentJoiner == currentUser.uid &&
                    nextJoiner &&
                    nextJoiner == key
                      ? key
                      : false
                  }
                  name={value.name}
                  currentJoiner={currentJoiner == key}
                />
              ) : (
                <div
                  className={styles.joinerName}
                  style={
                    currentJoiner == currentUser.uid
                      ? {
                          color: "#096dd9",
                          fontWeight: "bolder",
                          width: "80px",
                          height: "60px",
                          overflowY: "auto",
                          lineHeight: "100%",
                        }
                      : {}
                  }
                >
                  {currentJoiner == currentUser.uid && (
                    <DownCircleTwoTone
                      style={{
                        fontSize: "12px",
                        position: "absolute",
                        top: "-15px",

                        left: "calc(50% - 5px)",
                      }}
                    />
                  )}
                  {value.name}
                </div>
              )}
            </div>
          );
        })}

      <div
        style={{
          position: "absolute",
          transform: `rotate(${arrowAngle}deg)`,
        }}
        id="direction"
      >
        {direction ? (
          direction == "CW" ? (
            <RedoOutlined style={directionStyle} />
          ) : (
            <UndoOutlined style={directionStyle} />
          )
        ) : (
          <PlayCircleFilled
            style={{
              color: iconColor,
              fontSize: `200px`,
              transitionDuration: "0.2s",
            }}
            onMouseOver={() => setIconColor("#91d5ff")}
            onMouseOut={() => setIconColor("#bae7ff")}
            onClick={startPlay}
          />
        )}
      </div>

      <div className={styles.card}>
        {state == "PLAY" && currentCard && (
          <>
            {previousCard && (
              <div style={{ position: "absolute" }}>
                <Card
                  name={previousCard.name}
                  distance={previousCard.distance}
                  color={previousCard.color}
                  fontColor={previousCard.fontColor}
                />
              </div>
            )}
            <div id="currentCard">
              <Card
                name={currentCard.name}
                distance={currentCard.distance}
                color={currentCard.color}
                fontColor={currentCard.fontColor}
                state={"currentCard"}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AllCard;
